import MensagemPadrao, { MessageType } from 'app/components/MensagemPadrao';
import React, { ReactNode, createContext, useState } from 'react';
import './styles/toast.css'
// import MensagemPadrao, { MessageType } from '../components/atoms/MensagemPadrao';

interface ToastContextProps {
    show: (props: any) => void
    hide: () => void
}

interface ToastProvider {
    children: ReactNode
}

export const ToastContext = createContext<ToastContextProps>({} as ToastContextProps);

export const ToastProvider = (props: ToastProvider) => {

    const [type, setType] = useState('');
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('')
    const [timeHide, setTimeHide] = useState(5000)
    const [isVisible, setIsVisible] = useState(false)

    const show = (props: any) => {
        setType(props.type)

        setTitle(props.title)
        setMessage(props.message)
        setTimeHide(props.timeout != undefined ? props.timeout : 5000)
        // setIsVisible(true)
   
        const div = document.getElementsByClassName('alert')[0];
        div.classList.add('show')
        div.classList.remove('hide')
        setTimeout(() => {
            div.classList.remove('show')
            div.classList.add('hide')
        }, props.timeout !== undefined ? props.timeout : 5000);
         
    }
    
    const hide = () => {
        // setIsVisible(false)
        setType('')
        setTitle('')
        setMessage('')
        setTimeHide(5000)
        const div = document.getElementsByClassName('alert')[0];
        div.classList.remove('show')
        div.classList.remove('hide')
    }

    return (
        <ToastContext.Provider value={{show, hide}}>
            {props.children}
            <div className={`alert ${type}`} >
                <span onClick={hide} className="closebtn">&times;</span>  
                <strong>{title}</strong>
                <p>{message}</p>
            </div>
        </ToastContext.Provider>
    );
}